import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[elemToScroll]'
})
export class ElemToScrollDirective {
	private wasScrolled = false;
	private scrollHash = localStorage.getItem('keyToScroll');

	@Input() elemToScroll: String;

	constructor(private element: ElementRef) {}

	ngOnInit(): void {
		if (this.scrollHash !== this.elemToScroll) {
			return;
		}
		if (!this.wasScrolled) {
			this.wasScrolled = true;
			// setTimeout with magic 500ms to compensate DOM redrawing time and get right position
			setTimeout(() => {
				const nativeElem: HTMLElement = this.element.nativeElement;
				const topScroll = nativeElem.getBoundingClientRect().top;
				// 115 - height of header and padding to not stick header with element
				document.documentElement.scrollTop = topScroll - 115;
				localStorage.removeItem('keyToScroll');
			}, 500);
		}
	}

	ngOnDestroy(): void {
		this.wasScrolled = false;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/directives/ElemToScroll/elemToScroll.directive.ts